import { FormControl, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { rtlLayoutAction, setLanguage } from 'redux/actions';
import { ArabicIcon } from './icons/arabic-icon';
import { EnglishIcon } from './icons/english-icon';

interface Language {
  name: string;
  icon: string;
  locale: string;
}

interface SettingsState {
  locale: Language;
  languages: Language[];
}

interface RootState {
  settings: SettingsState;
}

const LanguageProvider: React.FC = () => {
  const { locale, languages } = useSelector((state: RootState) => state.settings);
  const dispatch = useDispatch();

  const onChangeLanguage = (e: React.ChangeEvent<{ value: unknown }>): void => {
    const lang = e.target.value as Language;
    if (locale !== lang) {
      dispatch(setLanguage(lang));
      rtlLayoutHandler(lang.locale === 'ar');
    }
  };

  const rtlLayoutHandler = (isTrue: boolean): void => {
    const dir = isTrue ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
    document.body.setAttribute('dir', dir);
    if (isTrue) {
      document.body.classList.add('rtl');
      localStorage.setItem('language', 'ar');
    } else {
      document.body.classList.remove('rtl');
      localStorage.setItem('language', 'en');
    }
    dispatch(rtlLayoutAction(isTrue));
  };

  const currentLocale = locale.name === languages[0].name ? languages[0] : languages[1];

  return (
    <FormControl className='no-border-select'>
      <Select name='language' id='language' value={currentLocale.name} onChange={onChangeLanguage}>
        {languages.map((language, index) => (
          <MenuItem key={index} value={language.name}>
            {language.icon === 'en' ? <EnglishIcon /> : <ArabicIcon />}
            <span style={{ margin: '0 10px' }}>{language.name}</span>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageProvider;
